import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { AdmonitionState } from './admonition-interfaces';

@injectable()
export class AdmonitionStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<AdmonitionState> {

  key = { id: 32, name: { ns: 'interaction-suspend-data', name: 'admonition' }, format: 'protobuf' }

  serialize(data: AdmonitionState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new AdmonitionStateProtoMessage({
      open: data.open,
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<AdmonitionStateProtoMessage>(message, AdmonitionStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<AdmonitionState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<AdmonitionStateProtoMessage>(content, AdmonitionStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: AdmonitionState = {
      open: message.open,
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('AdmonitionStateProtoMessage')
class AdmonitionStateProtoMessage extends Message<AdmonitionStateProtoMessage> {
  @Field.d(1, 'bool', 'optional', false)
  open: boolean;

  @Field.d(2, 'bool', 'optional', false)
  touched: boolean;
}
